import { OptionItems } from 'app/models';
import clsx from 'clsx';
import { FieldHookConfig, useField } from 'formik';
import _ from 'lodash';
import React from 'react';
import Select from 'react-select';
import { Label } from 'reactstrap';

interface OtherProps {
  label: string;
  horizontal?: boolean;
  placeholder?: string;
  options: OptionItems[];
  onChange?: (value?: any) => void;
  isClearable?: boolean;
  disabled?: boolean;
  isInModal?: boolean;
}

const SelectField = (props: OtherProps & FieldHookConfig<string>) => {
  const [field, meta, helpers] = useField(props);
  const {
    label,
    placeholder,
    options,
    onChange,
    isClearable,
    disabled,
    isInModal = false,
  } = props;
  const rendervalue = () => {
    const index = _.findIndex(options, option => option.value === field.value);
    if (index > -1) {
      return options[index];
    }
    return '';
  };
  return (
    <div
      className={clsx(
        'mb-2',
        'form-group',
        meta.touched && meta.error && 'text-danger',
      )}
      style={{ height: 85 }}
    >
      {label ? <Label>{props.label}</Label> : null}
      <Select
        // value={selectedMulti}
        defaultValue={rendervalue()}
        isMulti={false}
        placeholder={placeholder}
        options={options}
        // formatOptionLabel={option => option.label}
        classNamePrefix="select2-selection"
        {...field}
        value={rendervalue()}
        onChange={e => {
          if (e) {
            helpers.setValue(e.value);
          } else {
            helpers.setValue('');
          }
          if (onChange) {
            onChange(e);
          }
        }}
        noOptionsMessage={() => '無選項'}
        isClearable={isClearable}
        isDisabled={disabled}
        menuPortalTarget={!isInModal ? document.body : undefined}
        styles={{
          menuPortal: base => ({
            ...base,
            zIndex: 9999,
          }),
        }}
      />
      {meta.touched && meta.error ? <div>{meta.error}</div> : null}
    </div>
  );
};

export default SelectField;
